import { UserDocument } from '@/features/user/your-practice/documents/lib/userDocuments.slice'
import { sortDocumentsByNameAscWithinStatementDateDesc } from '@/features/user/your-practice/documents/lib/helpers'
import { Card } from '@/ui'
import { FeatureStateProvider } from '@/features/user/your-practice/documents/lib/state'
import { TableHeaderConfig } from '@/features/user/your-practice/documents/table/index'
import { UserDocumentsTable } from '@/features/user/your-practice/documents/table'
import { GroupByEnum } from '@/features/user/your-practice/documents/table/helpers'
import { RowTypes } from '../user/your-practice/documents/table/TableRows'
import { ConfirmDeleteDocumentDialog } from '@/features/user/your-practice/documents/shared/ConfirmDeleteDocumentDialog'

const getTableColumns = (
  editable: boolean | undefined
): TableHeaderConfig[] => {
  return [
    {
      sortBy: 'fileName',
      title: 'File Name',
    },
    {
      sortBy: 'tag',
      title: 'Statement Month',
    },
    {
      sortBy: 'financialAccount',
      title: 'Financial Account',
    },
    ...(editable
      ? [
          {
            sortBy: null,
            title: 'Actions',
          },
        ]
      : []),
  ]
}

export const EditableStatementTable = ({
  documents,
  editable,
}: {
  documents: UserDocument[]
  editable?: boolean
}) => {
  const tableColumns = getTableColumns(editable)
  return (
    <FeatureStateProvider>
      <Card className="w-full">
        <UserDocumentsTable
          documents={documents}
          // TODO: Migrate to V2 skipcq: JS-0099
          // RowComponent={(props) => (
          //   <OnboardingStatementRow {...props} editable={editable} />
          // )}
          tableOptions={{
            sortFn: sortDocumentsByNameAscWithinStatementDateDesc,
            groupBy: GroupByEnum.None,
          }}
          rowType={RowTypes.BANK_STATEMENT}
          columns={tableColumns}
        />
        <ConfirmDeleteDocumentDialog />
      </Card>
    </FeatureStateProvider>
  )
}
